import agGridLicense from './aggrid-license';
import { Environment } from './environment.type';

export const environment: Environment = {
  production: true,
  api_domain: 'api-uat',
  appsyncChat: '3yyeevywhnh7tifg2hrfbvxr24',
  raygunApiKey: 'Rqhmee4BvCTjWFZ9tUcCQ',
  websocket: 'wss://dhzcp3gvz5.execute-api.eu-west-1.amazonaws.com/uat/',
  phxEndpoint: 'wss://mon.uat.fxexotics.com',
  cloudWatch: {
    region: 'eu-west-1',
    accessKeyId: 'AKIA3TOJLY2HXR3BY5ZQ',
    secretAccessKey: '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',
    logNames: {
      logGroupName: '/hydra-medusa/gui',
      logStreamName: 'uat'
    }
  },
  agGridLicense,
  featureFlags: {
    enablePhxDirectMessaging: true,
    enableDesktopNotifications: true,
    enablePnlPivotBlotter: true,
    logEntityMapper: true,
    enableDuplicateLoginsAlert: true,
    enableMedusaJWTLogin: true,
    enableSpotExecutionModes: true,
    enableLiveAutoHedgeForStrips: true
  }
};
